import { defineComponent as s, toRef as o } from "vue";
import { addFormFieldErrorHandling as m, addFormFieldBehavior as p } from "./index5.js";
import { MsWarningCircle as c, MsDisabled as g } from "@sunrise/icons";
const S = s({
  name: "CsInputField",
  components: {
    MsDisabled: g,
    MsWarningCircle: c
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: String,
      default: "",
      required: !0
    },
    autoFocus: Boolean,
    errorMsg: String,
    isInactive: Boolean,
    label: String,
    regex: String,
    disabled: {
      type: Boolean,
      default: !1
    },
    inputmode: {
      type: String
    }
  },
  setup(e) {
    const t = m(o(e, "errorMsg")), { hasFocus: r, input: n, showReset: a, onInput: i, onBlur: l, onFocus: u, reset: d } = p({
      initialValue: o(() => e.modelValue),
      autoFocus: o(() => e.autoFocus),
      validation: {
        pattern: e.regex
      }
    });
    return {
      hasError: t,
      hasFocus: r,
      input: n,
      showReset: a,
      onInput: i,
      onFocus: u,
      onBlur: l,
      reset: d
    };
  }
});
export {
  S as default
};
